export const CHANGE_REGISTER_FORM_FIELD = 'CHANGE_REGISTER_FORM_FIELD' as const
export const REGISTER_REQUEST = 'REGISTER_REQUEST' as const
export const REGISTER_REQUEST_SUCCESS = 'REGISTER_REQUEST_SUCCESS' as const
export const REGISTER_REQUEST_FAILURE = 'REGISTER_REQUEST_FAILURE' as const
export const VALIDATE_REGISTER_FIELD = 'VALIDATE_REGISTER_FIELD' as const
export const ADD_REGISTER_FIELD_ERROR = 'ADD_REGISTER_FIELD_ERROR' as const
export const CLEAR_REGISTER_FIELD_ERROR = 'CLEAR_REGISTER_FIELD_ERROR' as const

export function changeRegisterFormField(key: string, value: string) {
  return { type: CHANGE_REGISTER_FORM_FIELD, payload: { key, value } }
}

export function registerRequest(p: {
  fullName: { value: string; validations?: string }
  email: { value: string; validations?: string }
  password: { value: string; validations?: string }
  registrationCode: { value: string; validations?: string }
}) {
  return { type: REGISTER_REQUEST, payload: p }
}

export function registerFailure(errors: Record<string, string>) {
  return { type: REGISTER_REQUEST_FAILURE, errors }
}

export function registerSuccess(userData: unknown) {
  return { type: REGISTER_REQUEST_SUCCESS, payload: { userData } }
}

export function addFieldError({ field, error }: { field: string; error: string }) {
  return { type: ADD_REGISTER_FIELD_ERROR, payload: { error, field } }
}

export function clearFieldError({ field }: { field: string }) {
  return { type: CLEAR_REGISTER_FIELD_ERROR, payload: { field } }
}

export function validateField({
  field,
  value,
  validations,
}: {
  field: string
  value: string
  validations?: string
}) {
  return { type: VALIDATE_REGISTER_FIELD, payload: { field, value, validations } }
}
